import styled from 'styled-components';

export const TabsSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  background: var(--color-neutral-11);
  border-radius: 12px;
  height: 36px;
  width: 100%;
  position: relative;
`;

export const Tab = styled.div<{ isActive: boolean }>`
  flex: 1;
  text-align: center;
  font-size: 12px;
  font-weight: ${({ isActive }) => (isActive ? 500 : 400)};
  color: ${({ isActive }) => (isActive ? '#fff' : 'var(--color-neutral-4)')};
  z-index: 100;
`;

export const ActiveTabBackground = styled.div<{
  activeTabPos: number;
  tabsCount: number;
}>`
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: ${({ activeTabPos, tabsCount }) =>
    `calc(${activeTabPos} * ${100 / tabsCount}%)`};
  width: ${({ tabsCount }) => `${100 / tabsCount}%`};
  background: var(--color-neutral-9);
  transition: 0.3s all ease-in-out;
  border-radius: 10px;
  margin-left: 2px;
`;

export const TabNumber = styled.span<{ isActive: boolean }>`
  font-size: 12px;
  font-weight: 500;
  margin-left: 4px;
  color: ${props =>
    props.isActive ? 'var(--color-primary-4)' : 'var(--color-neutral-6)'};
`;
